import { render, staticRenderFns } from "./UserChip.vue?vue&type=template&id=5a91f00a&scoped=true&"
import script from "./UserChip.vue?vue&type=script&lang=ts&"
export * from "./UserChip.vue?vue&type=script&lang=ts&"
import style0 from "./UserChip.vue?vue&type=style&index=0&id=5a91f00a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a91f00a",
  null
  
)

export default component.exports